window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('jquery-ui/ui/widgets/datepicker.js');
    require('jquery-ui/ui/widgets/sortable.js');
    require('jquery-ui/ui/widgets/autocomplete.js');

    require('block-ui/jquery.blockUI.js');

    //window.Dropzone = 
    require('dropzone/dist/dropzone-min');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.bootbox = require('bootbox');

//fix bootbox over modal removing scrollbars https://stackoverflow.com/questions/41891012/bootbox-modal-is-not-scrollable-after-a-second-modal-is-opened
$(function(){
    $(document).on('hidden.bs.modal', '.bootbox.modal', function (e) {    
        if($(".modal").hasClass('show')) {
            $('body').addClass('modal-open');
        }

        
    })

    $(document).on('hidden.bs.modal', '.ajax-modal', function (e) {    
        $(this).remove();

        if($(".modal").hasClass('show')) {
            $('body').addClass('modal-open');
        }
    })

    //https://stackoverflow.com/questions/19305821/multiple-modals-overlay
    $(document).on('show.bs.modal', '.modal', function() {
        const zIndex = 1040 + 10 * $('.modal:visible').length;
        $(this).css('z-index', zIndex);
        setTimeout(() => $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack'));

        $.fn.modal.Constructor.prototype.enforceFocus = function () { };
    });
});

window.axios = require('axios');

window.AutoNumeric = require('autonumeric');

// import numeral from 'numeral';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
